'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebAPIEvents = exports.registerEventHandlers = exports.createDeskproApiClient = undefined;

var _DeskproAPIClient = require('./DeskproAPIClient');

var _DeskproAPIClient2 = _interopRequireDefault(_DeskproAPIClient);

var _events = require('./events');

var WebAPIEvents = _interopRequireWildcard(_events);

var _EventHandler = require('../Core/EventHandler');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Registers the WebAPI events with the event dispatching system
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {AppClient} app
 */
function registerEventHandlers(windowBridge, app) {
  "use strict";

  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, WebAPIEvents.EVENT_WEBAPI_REQUEST_DESKPRO, WebAPIEvents.props.EVENT_WEBAPI_REQUEST_DESKPRO);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, WebAPIEvents.EVENT_WEBAPI_REQUEST_FETCH, WebAPIEvents.props.EVENT_WEBAPI_REQUEST_FETCH);
}

/**
 * @param {AppEventEmitter} eventDispatcher
 * @return {DeskproAPIClient}
 */
/**
 * This module exports the interface of the WebAPI package
 * @module WebAPI
 */

function createDeskproApiClient(eventDispatcher) {
  "use strict";

  return new _DeskproAPIClient2.default(eventDispatcher);
}

exports.createDeskproApiClient = createDeskproApiClient;
exports.registerEventHandlers = registerEventHandlers;
exports.WebAPIEvents = WebAPIEvents;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/WebAPI/index.js
// module id = 67
// module chunks = 0